import getDynamicAggregateFirstHeaders from './dynamic-aggregate-first-headers'

const notPlayerTypes = new Set(['batting-team', 'pitching-team', 'league'])

export default function getBatTrackingFirstHeaders(
    type = 'batter',
    secondaryGroupBy = []
) {
    const isNotPlayer = notPlayerTypes.has(type)
    const pitchHandRedundancy =
        type === 'pitcher' && secondaryGroupBy.includes('pitch_hand')
    const batSideRedundancy =
        type === 'batter' && secondaryGroupBy.includes('bat_side')
    const hideSide = isNotPlayer || batSideRedundancy || pitchHandRedundancy

    const hiddenSideClass = hideSide ? 'hidden' : ''

    const link = '?stats=statcast-r-bat_tracking-mlb#statcast_bat_tracking'
    const standardFirstHeaders = getDynamicAggregateFirstHeaders(type, link)

    return [
        ...standardFirstHeaders,

        {
            name: 'Side',
            field: 'bat_side_formatted',
            headerClass: `th-component-header align-center th-vertical-bottom ${hiddenSideClass}`,
            fieldClass: `tr-data align-center ${hiddenSideClass}`,
            defaultSortDir: 'asc',
        },
    ]
}
